import { render, staticRenderFns } from "./ai-confirm.vue?vue&type=template&id=793c217b&lang=html"
import script from "./ai-confirm.vue?vue&type=script&lang=js"
export * from "./ai-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports